export default {
  cities: []
}
